<script>

import lang from '@/filters/lang.filter';

export default {
  name: 'UlHeader',
  props: {
    title: String,
  },
  watch: {
    title() {
      this.setTitle();
    },
  },
  methods: {
    setTitle() {
      window.MagTemplate.title = lang.get(this.title);
    },
  },
  mounted() {
    this.setTitle();
  },
};
</script>
<template>
  <div></div>
</template>
<style lang="scss">
  .ul-header {
    position: sticky;
    top: 0;
    background: #ffffff;
    width: 100%;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    z-index: 999;

    &__main {
      display: flex;
      align-items: center;
      padding: 8px 4px;
    }

    &__title {
      line-height: 50px;
      font-size: 22px;
      padding: 0 16px;
      font-weight: 400;
      flex: 1;
      text-transform: uppercase;
    }

    .ul-btn-icon {
      color: #1b2f3f;
      background: none;
      box-shadow: none;
      height: 42px;
      width: 42px;
      margin: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;

      &:hover {
        background-color: rgba(158, 158, 158, .2);
      }

      &:active {
        background-color: rgba(158, 158, 158, .4);
      }

      &:focus {
        background-color: rgba(0, 0, 0, .12);
      }
    }
  }
</style>
